import { Card } from "@/components/ui/Card";
import useDocumentTitle from "@/hooks/UseDocumentTitle";
import TicketList from "./components/TicketList";

const UserTicketListing = () => {
  useDocumentTitle("Tickets");

  return (
    <div className="w-full p-5 pt-2">
      <TicketList />
    </div>
  );
};

export default UserTicketListing;
